/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEmailUpdate} from '../api'

 export const useQueryGetEmailUpdate = createReactQueryHook('getEmailUpdate', getEmailUpdate)
